import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import './InventoryCalculator.css';

const InitialItemRecoveryPage = ({ onComplete }) => {
  return (
    <div className="ic-page">
      <div className="ic-title-wrapper">
        <h2 className="ic-title">Initial Item Recovery</h2>
      </div>

      <div className="ic-card">
        <div className="ic-card-inner">
          <div className="ic-logo-circle">
            <FontAwesomeIcon icon={faClipboardList} className="ic-logo" />
          </div>

          <h3 className="ic-heading">
            Calculate Your Starting
            <br />
            Inventory
          </h3>

          <p className="ic-desc">
            Instantly calculate your starting inventory with zero effort using two past purchase bills.
            Our system cross-references the data to set accurate stock levels automatically, skipping hours of
            manual counting.
          </p>

          <button className="ic-cta" onClick={() => onComplete && onComplete()}>
            Let's Get Started
          </button>
        </div>
      </div>

      <div className="ic-footnote">Get an immediate forecast of ingredient needs</div>
    </div>
  );
};

export default InitialItemRecoveryPage;